import React from 'react'
import SmartManufBlock from './SmartManufBlock/SmartManufBlock'
import Header from '../../Modules/Header/Header'

const SmartManufacturing = () => {
  return (
    <div>
      <Header />
      <SmartManufBlock />
    </div>
  )
}

export default SmartManufacturing
